<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import type { CalendarDisplayControls } from "../../../../../../../../calendar-api"
  import type { CalendarDateRange } from "../../_shared/_logic/calendar-date-range"
  import type { EmployeeOption } from "../../../../../../../../_shared/_logic/calendar-types"

  interface Props {
    calendarControls: CalendarDisplayControls
    employees: EmployeeOption[]
    selectedEmployee?: string | string[]
    dateRange?: CalendarDateRange
    onDateRangeChange?: (value: unknown) => void
    onEmployeeChange?: (value: unknown) => void
    allowMulti?: boolean
    showEmployeeSelect?: boolean
    eventsLoading?: boolean
  }

  let {
    calendarControls,
    employees,
    selectedEmployee = $bindable(""),
    dateRange = $bindable<CalendarDateRange>({ start: null, end: null }),
    onDateRangeChange = () => {},
    onEmployeeChange = () => {},
    allowMulti = true,
    showEmployeeSelect = true,
    eventsLoading = false,
  }: Props = $props()
</script>

<div class="calendar-filterbar form">
  <div class="toolbar-row" class:with-grid={calendarControls.view === "timeline"}>
    <Input
      type="dateRange"
      classList="date-range-picker"
      brightBackground={true}
      bind:value={dateRange}
      placeholder="Terminzeitraum"
      disabled={eventsLoading}
      dateGranularity="day"
      tooltip="Filtert den Kalender nach dem ausgewählten Terminzeitraum."
      onChange={(event) => onDateRangeChange(event)}
    />

    {#if showEmployeeSelect}
      <Input
        type="select"
        classList="employee-select"
        brightBackground={true}
        placeholder="Mitarbeiter auswählen…"
        options={employees.map((emp) => ({ name: emp.label, value: emp.id }))}
        multiple={allowMulti}
        disabled={eventsLoading}
        tooltip="Filtert den Kalender nach Mitarbeiter:in (Mehrfachauswahl möglich)."
        bind:value={selectedEmployee}
        onChange={(event) => onEmployeeChange(event)}
      />
    {/if}
    {#if calendarControls.view === "timeline"}
      <Input
        type="select"
        classList="grid-select"
        brightBackground={true}
        placeholder="Zeitraster"
        clearable={false}
        options={calendarControls.gridOptions.map((minutes) => ({
          name: `${minutes} Minuten`,
          value: String(minutes),
        }))}
        value={String(calendarControls.gridMinutes)}
        tooltip="Bestimmt die zeitliche Einteilung und Höhe des Zeitplans. Termine bleiben unverändert."
        onValueChange={(value) => {
          const minutes = calendarControls.gridOptions.find((option) => String(option) === value)

          if (minutes !== undefined) calendarControls.onGridChange(minutes)
        }}
      />
    {/if}
  </div>
</div>

<style lang="less">
  @import "@kontextwerk/web-sdk/theme/tokens.less";

  .calendar-filterbar {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    padding-bottom: 1.2rem;

    .toolbar-row {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 1.2rem;
      align-items: center;

      &.with-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr)) minmax(150px, 0.45fr);
      }
    }

    :global(.date-range-picker),
    :global(.employee-select),
    :global(.grid-select) {
      min-width: 0;
      width: 100%;
    }

    @media (max-width: 767px) {
      .toolbar-row,
      .toolbar-row.with-grid {
        grid-template-columns: minmax(0, 1fr);
      }
    }
  }
</style>
